import React, { FC, useState } from "react";
import { Employee } from "../models";
import { TextField } from "@mui/material";
import EmployeeHubs from "./EmployeeHubs";
import employeeService from "services/employeeService";
import { Link } from "react-router-dom";
import MDButton from "components/MDButton";
import { toast } from "react-toastify";
import * as Yup from "yup";
import EmployeeRoles from "./EmployeeRoles";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

export interface EmployeeProps {
  employee: Employee;
  setEmployee(employee: Employee): any;
  reloadEmployee(): any;
}
export interface EmployeeErrors {
  email: string;
}
export interface EmployeeUpdate{
  email: string;
}
const EmployeeEdit: FC<EmployeeProps> = (props) => {
  const [errors, setErrors] = useState<EmployeeErrors>();

  const vehicleSchema: any = Yup.object().shape({
    email: Yup.string().matches(/^[\w\.-]+@railcrewxpress\.com$/gi,{ message:"Email must end with @railcrewxpress.com"}),
  });

  function validate() {
    try {
      vehicleSchema.validateSync(props?.employee, { abortEarly: false });
      setErrors({
        email: "",
      });
      return true;
    } catch (error) {
      let validation = error as Yup.ValidationError;
      const newErrors = validation.inner.reduce((acc: any, cur: any) => {
        acc[cur.path] = cur.message;
        return acc;
      }, {});
      setErrors(newErrors);
      return false;
    }
  }

  const update = ()=>{
    if (!validate()) return;
    
    employeeService.updateEmployee(props.employee!.id, props.employee.email)
    .then(()=>toast.success("Employee Updated"));
  }
  return (
    <>
      {props.employee && (
        <>
        <Grid mt={1}>
          <Card>
          <MDBox p={3}>
            <MDTypography variant="h5">Basic Info</MDTypography>
          </MDBox>
          <MDBox component="form" pb={3} px={3}>
            <Grid container spacing="2">
              <Grid item xs={12} md={4}>
                {" "}
                <MDTypography variant="body2" color="text">
                  <b>Title:</b> {props.employee.title ?? "N/A"}
                </MDTypography>
              </Grid>
              <Grid item xs={12} md={4}>
                {" "}
                <MDTypography variant="body2" color="text">
                  <b>Termination Date:</b> {props.employee.terminationDate ?? "N/A"}
                </MDTypography>
              </Grid>
              <Grid item xs={12} md={4}>
                {" "}
                <MDTypography variant="body2" color="text">
                  <b>Is Active:</b> {props.employee.isActive ? "True" : "False"}
                </MDTypography>
              </Grid>
              <Grid item xs={12} md={4} sx={{ mt: 2, pr: 2 }}>
                <TextField
                  value={props.employee.email}
                  inputProps={{ maxLength: 255 }}
                  label="Email"
                  fullWidth
                  error={!!errors?.email}
                  helperText={errors?.email}
                  onChange={(e) =>
                    props.setEmployee({
                      ...props.employee,
                      email: e.target.value,
                    })
                  }
                />
              </Grid>
            </Grid>

            <Grid container spacing={2} sx={{ pt: 2, pb: 2, pr: 4 }}>
              <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }}>
                <MDButton variant="text" color="secondary" to="/employees" component={Link}>
                  Cancel
                </MDButton>
                <MDButton variant="contained" color="dark" disabled={!props.employee?.driver} onClick={update}>
                  Update
                </MDButton>
              </Grid>
            </Grid>
            </MDBox>
          </Card>
          </Grid>
          <Grid container spacing="2">
            <EmployeeHubs
              employee={props.employee}
              setEmployee={props.setEmployee}
              reloadEmployee={props.reloadEmployee}
            />
          </Grid>
          <Grid container spacing="2">
            <EmployeeRoles employee={props.employee}/>
          </Grid>
        </>
      )}
    </>
  );
};
export default EmployeeEdit;
